import { sumBy } from 'lodash'

function sumUpParticipantsSummaryDataNotificationServices(summaryData) {
  return {
    totalPlans: summaryData.length,
    totalParticipants: sumBy(summaryData, 'participants'),
  }
}

export default sumUpParticipantsSummaryDataNotificationServices
